export const Privacy = () => {
  return (
    <main className="container mx-auto px-4 py-8 mb-auto relative">
      <h2 className="text-xl font-semibold">Privacy Policy</h2>
      <div>
        <h2 className="text-xl font-semibold">Introduction</h2>
        <p>
          We are a data sharing network and online platform for professionals.
          People use our Services to find and share information for business
          purposes and to connect with others. Our Privacy Policy applies to any
          Member or Visitor to our Services.
        </p>

        <p>
          Our registered users (“Members”) share their professional identities,
          engage with their network, exchange knowledge and technical
          information, post and view relevant content. Content and data on some
          of our Services is viewable to non-members (“Visitors”).
        </p>

        <h3 className="text-lg font-semibold">Services</h3>
        <p>
          This Privacy Policy, including our Cookie Policy applies to your use
          of our Services.
        </p>

        <p>
          This Privacy Policy applies to FoundAt.com, FoundAt-branded apps, and
          services (“Services”), including off-site Services, such as our ad
          services but excluding services that state that they are offered under
          a different privacy policy.
        </p>

        <h3 className="text-lg font-semibold">
          Data Controllers and Contracting Parties
        </h3>
        <p>
          FoundAt Pty Ltd, a company registered in Australia (“FoundAt”) will be
          the controller of your personal data provided to, or collected by or
          for, or processed in connection with our Services.
        </p>

        <p>
          As a Visitor or Member of our Services, the collection, use and
          sharing of your personal data is subject to this Privacy Policy and
          other documents referenced in this Privacy Policy, as well as updates.
        </p>

        <h2 className="text-xl font-semibold">Change</h2>
        <p>
          Changes to the Privacy Policy apply to your use of our Services after
          the “effective date.”
        </p>
        <p>
          FoundAt (“we” or “us”) can modify this Privacy Policy, and if we make
          material changes to it, we will provide notice through our Services,
          or by other means, to provide you the opportunity to review the
          changes before they become effective. If you object to any changes,
          you may close your account.
        </p>
        <p>
          You acknowledge that your continued use of our Services after we
          publish or send a notice about our changes to this Privacy Policy
          means that the collection, use and sharing of your personal data is
          subject to the updated Privacy Policy, as of its effective date.
        </p>

        <h3 className="text-lg font-semibold">1. Data We Collect</h3>

        <h4 className="font-semibold">1.1 Data You Provide To Us</h4>
        <p>You provide data to create an account with us.</p>

        <h5 className="font-semibold">Registration</h5>
        <p>
          To create an account you need to provide data including your name,
          email address and/or mobile number, and a password. If you register
          for a premium Service, you will need to provide payment (e.g., credit
          card) and billing information.
        </p>

        <p>
          You create your FoundAt profile (a complete profile helps you get the
          most from our Services).
        </p>

        <h5 className="font-semibold">Profile</h5>
        <p>
          You have choices about the information on your profile, such as your
          photo, city or area. It’s your choice whether to include sensitive
          information on your profile and to make that sensitive information
          public. Please do not post or add personal data to your profile that
          you would not want to be publicly available.
        </p>

        <p>
          You give other data to us, such as by syncing your address book or
          calendar.
        </p>

        <h5 className="font-semibold">Posting and Uploading</h5>
        <p>
          We collect personal data from you when you provide, post or upload it
          to our Services, such as when you fill out a form on our Services. If
          you opt to make a post viewable by the public, it is important that
          you do not create that post at a location that would identify any
          personal details that you would not wish to be made public, such as
          your residential address, or employment address, etc.
        </p>

        <p>
          You don’t have to post or upload personal data; though if you don’t,
          it may limit your ability to grow and engage with your network over
          our Services.
        </p>

        <h4 className="font-semibold">1.2 Data From Others</h4>

        <h5 className="font-semibold">Content and News</h5>
        <p>
          You and others may post content that includes information about you
          (as part of articles, posts, comments, videos) on our Services. We
          also may collect public information about you, such as
          professional-related news and accomplishments, and make it available
          as part of our Services, including, as permitted by your settings, in
          notifications to others of mentions in the news.
        </p>

        <p>Customers and partners may provide data to us.</p>

        <h5 className="font-semibold">Partners</h5>
        <p>
          We receive personal data (e.g., your job title and work email address)
          about you when you use the services of our customers and partners,
          such as employers or prospective employers and applicant tracking
          systems providing us job application data.
        </p>

        <h5 className="font-semibold">Related Companies and Other Services</h5>
        <p>
          We receive data about you when you use some of the other services
          provided by us or our affiliates, including Microsoft. For example,
          you may choose to send us information about your contacts in Microsoft
          apps and services, such as Outlook, for improved professional
          networking activities on our Services.
        </p>

        <h3 className="text-lg font-semibold">1.3 Service Use</h3>
        <p>
          We log your visits and use of our Services, including mobile apps.
        </p>
        <p>
          We log your location data only for the purposes of precisely locating
          the posts that you create in the world or for correctly displaying
          Augmented Reality content in your present location.
        </p>
        <p>
          We log usage data when you visit or otherwise use our Services,
          including our sites, app and platform technology, such as when you
          view or click on content (e.g., learning video) or ads (on or off our
          sites and apps), perform a search, install or update one of our mobile
          apps, share articles or apply for jobs. We use log-ins, cookies,
          device information and internet protocol (“IP”) addresses to identify
          you and log your use.
        </p>

        <h4 className="font-semibold">1.4 Cookies and Similar Technologies</h4>
        <p>We collect data through cookies and similar technologies.</p>
        <p>
          As further described in our Cookie Policy, we use cookies and similar
          technologies (e.g., pixels and ad tags) to collect data (e.g., device
          IDs) to recognize you and your device(s) on, off and across different
          services and devices where you have engaged with our Services. We also
          allow some others to use cookies as described in our Cookie Policy. If
          you are outside the Designated Countries, we also collect (or rely on
          others who collect) information about your device where you have not
          engaged with our Services (e.g., ad ID, IP address, operating system
          and browser information) so we can provide our Members with relevant
          ads and better understand their effectiveness. Learn more. You can opt
          out from our use of data from cookies and similar technologies that
          track your behavior on the sites of others for ad targeting and other
          ad-related purposes. For Visitors, the controls are here.
        </p>

        <h4 className="font-semibold">1.5 Your Device and Location</h4>
        <p>We receive data through cookies and similar technologies.</p>
        <p>
          When you visit or leave our Services (including some plugins and our
          cookies or similar technology on the sites of others), we receive the
          URL of both the site you came from and the one you go to and the time
          of your visit. We also get information about your network and device
          (e.g., IP address, proxy server, operating system, web browser and
          add-ons, device identifier and features, cookie IDs and/or ISP, or
          your mobile carrier). If you use our Services from a mobile device,
          that device will send us data about your location based on your phone
          settings. We will ask you to opt-in before we use GPS or other tools
          to identify your precise location.
        </p>

        <h4 className="font-semibold">1.6 Messages</h4>
        <p>If you communicate through our Services, we learn about that.</p>
        <p>
          We collect information about you when you send, receive, or engage
          with messages in connection with our Services. For example, if you get
          a FoundAt connection request, we track whether you have acted on it
          and will send you reminders. We also use automatic scanning technology
          on messages to support and protect our site. For example, we use this
          technology to suggest possible responses to messages and to manage or
          block content that violates our User Agreement or Professional
          Community Policies from our Services.
        </p>

        <h4 className="font-semibold">1.7 Workplace and School Provided Information</h4>
        <p>
          When your organization (e.g., employer or school) buys a premium
          Service for you to use, they give us data about you.
        </p>
        <p>
          Others buying our Services for your use, such as your employer,
          provide us with personal data about you and your eligibility to use
          the Services that they purchase for use by their workers. For example,
          we will get contact information for “Company Page” administrators and
          for authorizing users of our premium Services, such as sales products.
        </p>

        <h4 className="font-semibold">1.8 Sites and Services of Others</h4>
        <p>
          We get data when you visit sites that include our ads, cookies or some
          of our plugins or when you log-in to others’ services with your
          FoundAt account.
        </p>
        <p>
          We receive information about your visits and interaction with services
          provided by others when you log-in with FoundAt or visit others’
          services that include some of our plugins (such as “Apply with
          FoundAt”) or our ads, cookies or similar technologies.
        </p>

        <h4 className="font-semibold">1.9 Other</h4>
        <p>
          We are improving our Services, which means we get new data and create
          new ways to use data.
        </p>
        <p>
          Our Services are dynamic, and we often introduce new features, which
          may require the collection of new information. If we collect
          materially different personal data or materially change how we
          collect, use or share your data, we will notify you and may also
          modify this Privacy Policy.
        </p>

        <h3 className="text-lg font-semibold">2. How We Use Your Data</h3>
        <p>
          We use your data to provide, support, personalize and develop our
          Services.
        </p>
        <p>
          How we use your personal data will depend on which Services you use,
          how you use those Services and the choices you make in your settings.
          We use the data that we have about you to provide and personalize our
          Services, including with the help of automated systems and inferences
          we make, so that our Services (including ads) can be more relevant and
          useful to you and others.
        </p>

        <h4 className="font-semibold">2.1 Services</h4>
        <p>
          Our Services help you connect with others, find and be found for work
          and business opportunities, stay informed, get training and be more
          productive.
        </p>
        <p>
          We use your data to authorize access to our Services and honor your
          settings.
        </p>

        <h5 className="font-semibold">Stay Connected</h5>
        <p>
          Our Services allow you to stay in touch and up to date with
          colleagues, partners, clients, and other professional contacts. To do
          so, you can “connect” with the professionals who you choose, and who
          also wish to “connect” with you. Subject to your and their settings,
          when you connect with other Members, you will be able to search each
          others’ connections in order to exchange professional opportunities.
        </p>
        <p>
          We use data about you (such as your profile, profiles you have viewed
          or data provided through address book uploads or partner integrations)
          to help others find your profile, suggest connections for you and
          others (e.g. Members who share your contacts or job experiences) and
          enable you to invite others to become a Member and connect with you.
          You can also opt-in to allow us to use your precise location or
          proximity to others for certain tasks (e.g. to suggest other nearby
          Members for you to connect with, calculate the commute to a new job,
          or notify your connections that you are at a professional event).
        </p>
        <p>
          It is your choice whether to invite someone to our Services, send a
          connection request, or allow another Member to become your connection.
          When you invite someone to connect with you, your invitation will
          include your network and basic profile information (e.g., name,
          profile photo, job title, region). We will send invitation reminders
          to the person you invited. You can choose whether or not to share your
          own list of connections with your connections.
        </p>

        <h5 className="font-semibold">Visitors have choices about how we use their data.</h5>
        <p>
          Our Services allow you to collaborate with colleagues, search for
          potential clients, customers, partners and others to do business with.
          Our Services allow you to communicate with other Members.
        </p>

        <h4 className="font-semibold">2.2 Premium Services</h4>
        <p>
          Our premium Services help paying users to search for and contact
          Members through our Services, such as searching for and contacting job
          candidates, sales leads and co-workers, manage talent and promote
          content through social media.
        </p>
        <p>
          We sell premium Services that provide our customers and subscribers
          with customized-search functionality and tools (including messaging
          and activity alerts). Customers can export limited information from
          your profile, such as name, headline, current company, current title,
          and general location (e.g., Sydney), such as to manage sales leads,
          unless you opt-out. We do not provide contact information to customers
          as part of these premium Services without your consent. Premium
          Services customers can store information they have about you in our
          premium Services, such as a resume or contact information or sales
          history. The data stored about you by these customers is subject to
          the policies of those customers.
        </p>

        <p>2.2 Premium Services</p>

        <p>
          Our premium Services help paying users to search for and contact
          Members through our Services, such as searching for and contacting job
          candidates, sales leads and co-workers, manage talent and promote
          content through social media.
        </p>

        <p>
          We sell premium Services that provide our customers and subscribers
          with customized-search functionality and tools (including messaging
          and activity alerts). Customers can export limited information from
          your profile, such as name, headline, current company, current title,
          and general location (e.g., Sydney), such as to manage sales leads,
          unless you opt-out. We do not provide contact information to customers
          as part of these premium Services without your consent. Premium
          Services customers can store information they have about you in our
          premium Services, such as a resume or contact information or sales
          history. The data stored about you by these customers is subject to
          the policies of those customers.
        </p>
        <h4 className="font-semibold">2.3 Communications</h4>

        <p>
          We contact you and enable communications between Members. We offer
          settings to control what messages you receive and how often you
          receive some types of messages.
        </p>

        <p>
          We will contact you through email, mobile phone, notices posted on our
          websites or apps, messages to your FoundAt inbox, and other ways
          through our Services, including text messages and push notifications.
          We will send you messages about the availability of our Services,
          security, or other service-related issues. We also send messages about
          how to use our Services, network updates, reminders, job suggestions
          and promotional messages from us and our partners. You may change your
          communication preferences at any time. Please be aware that you cannot
          opt out of receiving service messages from us, including security and
          legal notices.
        </p>

        <p>
          We also enable communications between you and others through our
          Services, including for example invitations, InMail, groups and
          messages between connections.
        </p>
        <h4 className="font-semibold">2.4 Advertising</h4>

        <p>
          We serve you tailored ads both on and off our Services. We offer you
          choices regarding personalized ads, but you cannot opt-out of seeing
          other ads.
        </p>

        <p>
          We target (and measure the performance of) ads to Members, Visitors
          and others both on and off our Services directly or through a variety
          of partners, using the following data, whether separately or combined:
        </p>

        <p>
          {" "}
          Data from advertising technologies on and off our Services, pixels, ad
          tags, cookies, and device identifiers;
        </p>
        <p>
          {" "}
          Member-provided information (e.g., profile, contact information, title
          and industry);
        </p>
        <p>
          {" "}
          Data from your use of our Services (e.g., search history, feed,
          content you read, who you follow or is following you, connections,
          groups participation, page visits, videos you watch, clicking on an
          ad, etc.), including as described in Section 1.3;
        </p>
        <p>
          {" "}
          Information from advertising partners, vendors and publishers; and
        </p>
        <p>
          {" "}
          Information inferred from data described above (e.g., using job titles
          from a profile to infer industry, seniority, and compensation bracket;
          using graduation dates to infer age or using first names or pronoun
          usage to infer gender; using your feed activity to infer your
          interests; or using device data to recognize you as a Member).
        </p>

        <p>
          We will show you ads called sponsored content which look similar to
          non-sponsored content, except that they are labeled as advertising
          (e.g., as &ldquo;ad&rdquo; or &ldquo;sponsored&rdquo;). If you take a
          social action (such as like, comment or share) on these ads, your
          action is associated with your name and viewable by others, including
          the advertiser. Subject to your settings, if you take a social action
          on the FoundAt Services, that action may be mentioned with related
          ads. For example, when you like a company we may include your name and
          photo when their sponsored content is shown.
        </p>
        <p>Ad Choices</p>

        <p>
          We adhere to self-regulatory principles for interest-based advertising
          and participate in industry opt-outs from such ads. This does not opt
          you out of receiving advertising; you will continue to get other ads
          by advertisers not listed with these self regulatory tools. You can
          also opt-out specifically from our uses of certain categories of data
          to show you more relevant ads. For Visitors, the setting is here.
        </p>
        <p>Info to Ad Providers</p>

        <p>
          We do not share your personal data with any third-party advertisers or
          ad networks except for: (i) hashed IDs or device identifiers (to the
          extent they are personal data in some countries); (ii) with your
          separate permission (e.g., in a lead generation form) or (iii) data
          already visible to any users of the Services (e.g., profile). However,
          if you view or click on an ad on or off our Services, the ad provider
          will get a signal that someone visited the page that displayed the ad,
          and they may, through the use of mechanisms such as cookies, determine
          it is you. Advertising partners can associate personal data collected
          by the advertiser directly from you with hashed IDs or device
          identifiers received from us. In such instances, we seek to
          contractually require such advertising partners to obtain your
          explicit, opt-in consent before doing so.
        </p>
        <h4 className="font-semibold">2.5 Marketing</h4>

        <p>We promote our Services to you and others.</p>

        <p>
          In addition to advertising our Services, we use Members&rsquo; data
          and content for invitations and communications promoting membership
          and network growth, engagement and our Services, such as by showing
          your connections that you have used a feature on our Services.
        </p>
        <h4 className="font-semibold">2.6 Developing Services and Research</h4>

        <p>We develop our Services and conduct research</p>
        <p>Service Development</p>

        <p>
          We use data, including public feedback, to conduct research and
          development for our Services in order to provide you and others with a
          better, more intuitive and personalized experience, drive membership
          growth and engagement on our Services, and help connect professionals
          to each other and to economic opportunity.
        </p>
        <p>Other Research</p>

        <p>
          We seek to create economic opportunity for Members of the global
          workforce and to help them be more productive and successful. We use
          the personal data available to us to research social, economic and
          workplace trends. In some cases, we work with trusted third parties to
          perform this research, under controls that are designed to protect
          your privacy. We publish or allow others to publish economic insights,
          presented as aggregated data rather than personal data.
        </p>
        <p>Surveys</p>

        <p>
          Polls and surveys are conducted by us and others through our Services.
          You are not obligated to respond to polls or surveys, and you have
          choices about the information you provide. You may opt-out of survey
          invitations.
        </p>
        <h4 className="font-semibold">2.7 Customer Support</h4>

        <p>We use data to help you and fix problems.</p>

        <p>
          We use data (which can include your communications) to investigate,
          respond to and resolve complaints and for Service issues (e.g., bugs).
        </p>
        <h4 className="font-semibold">2.8 Insights That Do Not Identify You</h4>

        <p>We use data to generate insights that do not identify you.</p>

        <p>
          We use your data to produce and share insights that do not identify
          you. For example, we may use your data to generate statistics about
          our members, their profession or industry, to calculate ad impressions
          served or clicked on, or to publish visitor demographics for a Service
          or create demographic workforce insights.
        </p>
        <h4 className="font-semibold">2.9 Security and Investigations</h4>

        <p>We use data for security, fraud prevention and investigations.</p>

        <p>
          We use your data (including your communications) for security purposes
          or to prevent or investigate possible fraud or other violations of our
          User Agreement and/or attempts to harm our Members, Visitors or
          others.
        </p>
        <h3 className="text-lg font-semibold">3. How We Share Information</h3>
        <h4 className="font-semibold">3.1 Our Services</h4>

        <p>
          Any data that you include on your profile and any content you post or
          social action (e.g., likes, follows, comments, shares) you take on our
          Services will be seen by others, consistent with your settings.
        </p>
        <p>Profile</p>

        <p>
          Your profile is fully visible to all Members and customers of our
          Services. Subject to your settings, it can also be visible to others
          on or off of our Services (e.g., Visitors to our Services or users of
          third- party search engines). As detailed in our Help Center, your
          settings, degree of connection with the viewing Member, the
          subscriptions they may have, their usage of our Services, access
          channels and search types (e.g., by name or by keyword) impact the
          availability of your profile and whether they can view certain fields
          in your profile.
        </p>
        <p>Posts, Likes, Follows, Comments, Messages</p>

        <p>
          Our Services allow viewing and sharing information including through
          posts, likes, follows and comments.
        </p>

        <p>
          {" "}
          When you share an article or a post (e.g., an update, image, video or
          article) publicly it can be viewed by everyone and re-shared anywhere
          (subject to your settings). Members, Visitors and others will be able
          to find and see your publicly-shared content, including your name (and
          photo if you have provided one).
        </p>
        <p>
          {" "}
          In a group, posts are visible to others in the group. Your membership
          in groups is public and part of your profile, but you can change
          visibility in your settings.
        </p>
        <p>
          {" "}
          Any information you share through companies&rsquo; or other
          organizations&rsquo; pages on our Services will be viewable by it and
          others who visit those pages.
        </p>
        <p>
          {" "}
          When you follow a person or organization, you are visible to others
          and that &ldquo;page owner&rdquo; as a follower.
        </p>
        <p>
          {" "}
          We let senders know when you act on their message, subject to your
          settings where applicable.
        </p>
        <p>
          {" "}
          Subject to your settings, we let a Member know when you view their
          profile.
        </p>
        <p>
          {" "}
          When you like or re-share or comment on another&rsquo;s content
          (including ads), others will be able to view these &ldquo;social
          actions&rdquo; and associate it with you (e.g., your name, profile and
          photo if you provided it).
        </p>

        <p>
          Your employer can see how you use Services they provided for your work
          (e.g. as a recruiter or sales agent) and related information. We will
          not show them your job searches or personal messages.
        </p>
        <p>Enterprise Accounts</p>

        <p>
          Subject to your settings, when you use workplace tools and services
          (e.g., interactive employee directory tools) certain of your data may
          also be made available to your employer or be connected with
          information we receive from your employer to enable these tools and
          services.
        </p>
        <h4 className="font-semibold">3.2 Communication Archival</h4>

        <p>
          Regulated Members may need to store communications outside of our
          Service.
        </p>

        <p>
          Some Members (or their employers) need, for legal or professional
          compliance, to archive their communications and social media activity,
          and will use services of others to provide these archival services. We
          enable archiving of messages by and to those Members outside of our
          Services. For example, a financial advisor needs to archive
          communications with her clients through our Services in order to
          maintain her professional financial advisor license.
        </p>
        <h4 className="font-semibold">3.3 Others&rsquo; Services</h4>

        <p>
          You may link your account with others&rsquo; services so that they can
          look up your contacts&rsquo; profiles, post your shares on such
          platforms, or enable you to start conversations with your connections
          on such platforms. Excerpts from your profile will also appear on the
          services of others.
        </p>

        <p>
          Subject to your settings, other services may look up your profile.
          When you opt to link your account with other services, personal data
          will become available to them. The sharing and use of that personal
          data will be described in, or linked to, a consent screen when you opt
          to link the accounts. For example, you may link your Twitter or WeChat
          account to share content from our Services into these other services,
          or your email provider may give you the option to upload your FoundAt
          contacts into its own service. Third-party services have their own
          privacy policies, and you may be giving them permission to use your
          data in ways we would not. You may revoke the link with such accounts.
        </p>

        <p>
          Subject to your settings, excerpts from your profile will appear on
          the services of others (e.g., search engine results, mail and calendar
          applications that show a user limited profile data of the person they
          are meeting or messaging, social media aggregators, talent and lead
          managers). &ldquo;Old&rdquo; profile information remains on these
          services until they update their data cache with changes you made to
          your profile.
        </p>
        <h4 className="font-semibold">3.4 Related Services</h4>

        <p>
          We share your data across our different Services and FoundAt
          affiliated entities.
        </p>

        <p>
          We will share your personal data with our affiliates to provide and
          develop our Services. We may combine information internally across the
          different Services covered by this Privacy Policy to help our Services
          be more relevant and useful to you and others. For example, we may
          personalize your feed or job recommendations based on your learning
          history.
        </p>
        <h4 className="font-semibold">3.5 Service Providers</h4>

        <p>We may use others to help us with our Services.</p>

        <p>
          We use others to help us provide our Services (e.g., maintenance,
          analysis, audit, payments, fraud detection, marketing and
          development). They will have access to your information as reasonably
          necessary to perform these tasks on our behalf and are obligated not
          to disclose or use it for other purposes.
        </p>
        <h4 className="font-semibold">3.6 Legal Disclosures</h4>

        <p>
          We may need to share your data when we believe it&rsquo;s required by
          law or to help protect the rights and safety of you, us or others.
        </p>

        <p>
          It is possible that we will need to disclose information about you
          when required by law, subpoena, or other legal process or if we have a
          good faith belief that disclosure is reasonably necessary to (1)
          investigate, prevent or take action regarding suspected or actual
          illegal activities or to assist government enforcement agencies; (2)
          enforce our agreements with you; (3) investigate and defend ourselves
          against any third-party claims or allegations; (4) protect the
          security or integrity of our Services (such as by sharing with
          companies facing similar threats); or (5) exercise or protect the
          rights and safety of FoundAt, our Members, personnel or others. We
          attempt to notify Members about legal demands for their personal data
          when appropriate in our judgment, unless prohibited by law or court
          order or when the request is an emergency. We may dispute such demands
          when we believe, in our discretion, that the requests are overbroad,
          vague or lack proper authority, but we do not promise to challenge
          every demand. To learn more see our Data Request Guidelines and
          Transparency Report.
        </p>
        <h4 className="font-semibold">3.7 Change in Control or Sale</h4>

        <p>
          We may share your data when our business is sold to others, but it
          must continue to be used in accordance with this Privacy Policy.
        </p>

        <p>
          We can also share your personal data as part of a sale, merger or
          change in control, or in preparation for any of these events. Any
          other entity which buys us or part of our business will have the right
          to continue to use your data, but only in the manner set out in this
          Privacy Policy unless you agree otherwise.
        </p>
        <h3 className="text-lg font-semibold">
          4. Your Choices &amp; Obligations
        </h3>
        <h4 className="font-semibold">4.1 Data Retention</h4>

        <p>
          We keep most of your personal data for as long as your account is
          open.
        </p>

        <p>
          We generally retain your personal data as long as you keep your
          account open or as needed to provide you Services. This includes data
          you or others provided to us and data generated or inferred from your
          use of our Services. Even if you only use our Services every few
          years, we will retain your information and keep your profile open,
          unless you close your account. In some cases we choose to retain
          certain information (e.g., insights about Services use) in a
          depersonalized or aggregated form.
        </p>
        <h4 className="font-semibold">4.2 Rights to Access and Control Your Personal Data</h4>

        <p>
          You can access or delete your personal data. You have many choices
          about how your data is collected, used and shared.
        </p>

        <p>
          We provide many choices about the collection, use and sharing of your
          data, from deleting or correcting data you include in your profile and
          controlling the visibility of your posts to advertising opt-outs and
          communication controls. We offer you settings to control and manage
          the personal data we have about you.
        </p>

        <p>For personal data that we have about you, you can:</p>

        <p>
          Delete Data: You can ask us to erase or delete all or some of your
          personal data (e.g., if it is no longer necessary to provide Services
          to you).
        </p>
        <p>
          Change or Correct Data: You can edit some of your personal data
          through your account. You can also ask us to change, update or fix
          your data in certain cases, particularly if it&rsquo;s inaccurate.
        </p>
        <p>
          Object to, or Limit or Restrict, Use of Data: You can ask us to stop
          using all or some of your personal data (e.g., if we have no legal
          right to keep using it) or to limit our use of it (e.g., if your
          personal data is inaccurate or unlawfully held).
        </p>
        <p>
          Right to Access and/or Take Your Data: You can ask us for a copy of
          your personal data and can ask for a copy of personal data you
          provided in machine readable form.
        </p>

        <p>
          Visitors can learn more about how to make these requests here. You may
          also contact us using the contact information below, and we will
          consider your request in accordance with applicable laws.
        </p>

        <p>
          Residents in the Designated Countries and other regions may have
          additional rights under their laws.
        </p>
        <h4 className="font-semibold">4.3 Account Closure</h4>

        <p>We keep some of your data even after you close your account.</p>

        <p>
          If you choose to close your FoundAt account, your personal data will
          generally stop being visible to others on our Services within 24
          hours. We generally delete closed account information within 30 days
          of account closure, except as noted below.
        </p>

        <p>
          We retain your personal data even after you have closed your account
          if reasonably necessary to comply with our legal obligations
          (including law enforcement requests), meet regulatory requirements,
          resolve disputes, maintain security, prevent fraud and abuse (e.g., if
          we have restricted your account for breach of our Professional
          Community Policies), enforce our User Agreement, or fulfill your
          request to "unsubscribe" from further messages from us. We will retain
          de-personalized information after your account has been closed.
        </p>

        <p>
          Information you have shared with others will remain visible after you
          close your account or delete the information from your own profile or
          mailbox, and we do not control data that other Members have copied out
          of our Services. Groups content and ratings or review content
          associated with closed accounts will show an unknown user as the
          source. Your profile may continue to be displayed in the services of
          others (e.g., search engine results) until they refresh their cache.
        </p>
        <h3 className="text-lg font-semibold">
          5. Other Important Information
        </h3>
        <h4 className="font-semibold">5.1. Security</h4>

        <p>
          We monitor for and try to prevent security breaches. Please use the
          security features available through our Services.
        </p>

        <p>
          We implement security safeguards designed to protect your data, such
          as HTTPS. We regularly monitor our systems for possible
          vulnerabilities and attacks. However, we cannot warrant the security
          of any information that you send us. There is no guarantee that data
          may not be accessed, disclosed, altered, or destroyed by breach of any
          of our physical, technical, or managerial safeguards. Please visit our
          Safety Center for additional information about safely using our
          Services, including two-factor authentication.
        </p>
        <h4 className="font-semibold">5.2. Cross-Border Data Transfers</h4>

        <p>We store and use your data outside your country.</p>

        <p>
          We process data both inside and outside of the United States and rely
          on legally-provided mechanisms to lawfully transfer data across
          borders. Learn more. Countries where we process data may have laws
          which are different from, and potentially not as protective as, the
          laws of your own country.
        </p>
        <h4 className="font-semibold">5.3 Lawful Bases for Processing</h4>

        <p>
          We have lawful bases to collect, use and share data about you. You
          have choices about our use of your data. At any time, you can withdraw
          consent you have provided by going to settings.
        </p>

        <p>
          We will only collect and process personal data about you where we have
          lawful bases. Lawful bases include consent(where you have given
          consent), contract (where processing is necessary for the performance
          of a contract with you (e.g., to deliver the FoundAt Services you have
          requested) and &ldquo;legitimate interests.&rdquo; Learn more.
        </p>

        <p>
          Where we rely on your consent to process personal data, you have the
          right to withdraw or decline your consent at any time and where we
          rely on legitimate interests, you have the right to object. Learn
          More. If you have any questions about the lawful bases upon which we
          collect and use your personal data, please contact our Data Protection
          Officer here.
        </p>
        <h4 className="font-semibold">5.4. Direct Marketing and Do Not Track Signals</h4>

        <p>
          Our statements regarding direct marketing and &ldquo;do not
          track&rdquo; signals.
        </p>

        <p>
          We currently do not share personal data with third parties for their
          direct marketing purposes without your permission. Learn more about
          this and about our response to &ldquo;do not track&rdquo; signals.
        </p>
        <h4 className="font-semibold">5.5. Contact Information</h4>

        <p>
          You can contact us or use other options to resolve any complaints.
        </p>

        <p>
          If you have questions or complaints regarding this Policy, please
          first contact FoundAt online. You can also reach us by physical mail.
        </p>
      </div>
    </main>
  );
};
